var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseCapabilities"},_vm._l((_vm.possibleCapabilities),function(possibleCapability){return _c('div',{key:possibleCapability.value,staticClass:"_wrapper"},[_c('BaseCapability',{attrs:{"included":_vm.isCapabilityIncluded(possibleCapability.label, _vm.capabilities),"icon":possibleCapability.icon,"to":{
        name: 'search',
        query: {
          capability: possibleCapability.label,
        },
      }}},[_vm._v(" "+_vm._s(possibleCapability.label)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }